/*
 *   Copyright (c) 2023 
 *   All rights reserved.
 */
import React, { useEffect, useState } from 'react'
import VmoDropdown from "../Modules/Dropdown/VmoDropdown"
import VmoDropdownHeader from "../Modules/Dropdown/VmoDropdownHeader"
import VmoDropdownItem from "../Modules/Dropdown/VmoDropdownItem"
import VmoDropdownMenu from "../Modules/Dropdown/VmoDropdownMenu"
import VmoInput from "../Elements/VmoInput"

const VmoCustomDropdown = ({
    dropdownProps = {},
    menu = {},
    input = {},
    header = null,
    options = [],
    item = {},
    extraAction = null,
    activeIndicator = false,
    onClick,
    value = [],
    multiple = false,
    tooltip = false,
    tooltipContent = '',
}) => {
    const [optionState, setOptionState] = useState([])

    useEffect(() => {
        setOptionState(options)
    }, [options])

    const findIsActive = option => {
        if (multiple) {
            return activeIndicator && value ? value.some(o => o === option.value) : false
        }
        return activeIndicator && value ? value === option.value : false
    }
    const onInputChange = (e) => {
        const searchQuery = e.target.value
        let sanitizedSearchQuery = searchQuery.toLowerCase();
        // if (!sanitizedSearchQuery.startsWith('+')) {
        //     sanitizedSearchQuery = '+' + sanitizedSearchQuery;
        // }

        let updated

        if (searchQuery === '') {
            updated = options
        } else {
            updated = options.filter(o => {
                const countryCode = o.text.toLowerCase();
                const name = o.content.toLowerCase();
                return name?.startsWith(sanitizedSearchQuery) || countryCode?.startsWith(sanitizedSearchQuery) || countryCode.includes(sanitizedSearchQuery) || name.includes(sanitizedSearchQuery)
            })
        }
        setOptionState(updated)
    }
    return (
        <React.Fragment>
            {tooltip ? (
                <VmoTooltip
                    content={tooltipContent}
                    size="mini"
                    position="top center"
                    trigger={
                        <VmoDropdown {...dropdownProps}>
                            <VmoDropdownMenu>
                                <VmoInput
                                    {...input}
                                    onClick={e => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                    }}
                                    onChange={onInputChange}
                                />
                                {header && <VmoDropdownHeader content={header} />}
                                <VmoDropdownMenu {...menu} scrolling>
                                    {optionState.length > 0 ? (
                                        optionState.map(option => (
                                            <VmoDropdownItem
                                                key={option.value}
                                                {...option}
                                                {...item}
                                                active={findIsActive(option)}
                                                onClick={e => {
                                                    if (multiple && Array.isArray(value)) {
                                                        let newList = []
                                                        if (value.some(val => val === option.value)) {
                                                            newList = value.filter(n => n !== option.value)
                                                        } else {
                                                            const currentSelected = value
                                                            newList = [...currentSelected, option.value]
                                                        }
                                                        onClick(newList)
                                                    } else {
                                                        onClick(option.value)
                                                    }

                                                    e.stopPropagation()
                                                }}
                                            />
                                        ))
                                    ) : (
                                        <p
                                            style={{
                                                position: 'relative',
                                                textAlign: 'center',
                                            }}
                                        >
                                            No Data Available
                                        </p>
                                    )}
                                    {extraAction && <VmoDropdownItem {...extraAction} />}
                                </VmoDropdownMenu>
                            </VmoDropdownMenu>
                        </VmoDropdown>
                    }
                />
            ) : (
                <VmoDropdown {...dropdownProps}>
                    <VmoDropdownMenu>
                        <VmoInput
                            {...input}
                            onClick={e => {
                                e.preventDefault()
                                e.stopPropagation()
                            }}
                            onChange={onInputChange}
                        />
                        {header && <VmoDropdownHeader content={header} />}
                        <VmoDropdownMenu {...menu} scrolling>
                            {optionState.length > 0 ? (
                                optionState.map(option => (
                                    <VmoDropdownItem
                                        key={option.value}
                                        {...option}
                                        {...item}
                                        active={findIsActive(option)}
                                        onClick={e => {
                                            if (multiple && Array.isArray(value)) {
                                                let newList = []
                                                if (value.some(val => val === option.value)) {
                                                    newList = value.filter(n => n !== option.value)
                                                } else {
                                                    const currentSelected = value
                                                    newList = [...currentSelected, option.value]
                                                }
                                                onClick(newList)
                                            } else {
                                                onClick(option.value)
                                            }

                                            e.stopPropagation()
                                        }}
                                    />
                                ))
                            ) : (
                                <p
                                    style={{
                                        position: 'relative',
                                        textAlign: 'center',
                                    }}
                                >
                                    No Data Available
                                </p>
                            )}
                            {extraAction && <VmoDropdownItem {...extraAction} />}
                        </VmoDropdownMenu>
                    </VmoDropdownMenu>
                </VmoDropdown>
            )}
        </React.Fragment>
    )
}

export default VmoCustomDropdown
